import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-secondary-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center text-lg">
                <i className="ri-film-line" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200/90 max-w-sm">
              {siteInfo.tagline}。把花絮、路透、侧拍、彩蛋与候场片段整理成独立合集，按分类浏览正片之外的细节。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-md bg-secondary-900 text-secondary-100 flex items-center justify-center">
                <i className="ri-mail-line" aria-hidden="true" />
              </span>
              <span className="text-sm text-secondary-200">{siteInfo.email}</span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">
              站点导航
            </h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  合集大厅
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-secondary-200 hover:text-accent-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">
              内容分类
            </h3>
            <ul className="flex flex-col gap-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/collections?cat=${cat.slug}`}
                    className="text-secondary-200 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">
              读者说明
            </h3>
            <p className="text-sm leading-relaxed text-secondary-200/90">
              站内内容仅围绕公开发布与现场流传的拍摄相关画面进行整理，不涉及私人行程与个人空间信息。若你有补充线索，欢迎通过联系我们提交。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 mt-4 text-sm text-accent-400 hover:text-accent-300 transition-colors"
            >
              提交线索
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>
            © {year} {siteInfo.name} · 私拍吃瓜花絮路透侧拍彩蛋候场合集站
          </p>
          <p>内容整理与编辑：吃瓜片场内容组</p>
        </div>
      </div>
    </footer>
  );
}